import React from 'react';
import { node, bool, number } from 'prop-types';

import { StyledFlex } from './css';

function RestrictContent({
  children,
  restrictContent = true,
  cushionContent = false,
  maxWidth = undefined,
}) {
  return (
    <StyledFlex
      flexWrap="wrap"
      justifyContent="space-between"
      width={1}
      maxWidth={maxWidth}
      margin="auto"
      restrictContent={restrictContent}
      cushionContent={cushionContent}
    >
      {children}
    </StyledFlex>
  );
}

RestrictContent.propTypes = {
  children: node.isRequired,
  restrictContent: bool,
  cushionContent: bool,
  maxWidth: number,
};

export default RestrictContent;
